(function () {
  const GIFT_ORDER_KEY = 'Gift order';
  const GIFT_MESSAGE_KEY = 'Gift message';
  const GIFT_FROM_KEY = 'Gift from';
  const LEGACY_NOTE_KEY = 'Gift note';
  const NOTE_DEBOUNCE_MS = 400;
  const noteTimers = new WeakMap();
  let persistQueue = Promise.resolve();
  let checkoutFlushing = false;

  function cartGiftBlock() {
    return document.querySelector('[data-cart-drawer] [data-gift-options]');
  }

  function syncPanel(block) {
    const checkbox = block.querySelector('[data-gift-checkbox]');
    const panel = block.querySelector('[data-gift-message]');
    const textarea = block.querySelector('[data-gift-textarea]');
    if (!checkbox || !panel) return;

    const isOpen = checkbox.checked;
    checkbox.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    panel.hidden = !isOpen;
    panel.classList.toggle('is-open', isOpen);

    if (!isOpen && textarea) textarea.value = '';
    if (isOpen) updateCount(block);
  }

  function updateCount(block) {
    const textarea = block.querySelector('[data-gift-textarea]');
    const count = block.querySelector('[data-gift-count]');
    if (!textarea || !count) return;

    const max = Number(block.getAttribute('data-gift-max')) || Number(textarea.maxLength) || 280;
    const remaining = Math.max(0, max - (textarea.value || '').length);
    count.textContent = remaining + ' characters';
  }

  function giftNoteText(isGift, message, fromValue) {
    if (!isGift) return '';

    const lines = ['Gift order: Yes'];
    if (fromValue) lines.push('From: ' + fromValue);
    if (message) lines.push('Gift message: ' + message);
    return lines.join('\n');
  }

  async function saveGiftState(payload) {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        note: payload.note,
        attributes: payload.attributes,
      }),
    });
    if (!response.ok) throw new Error('Gift message could not be saved');
    return response.json();
  }

  function persistFromBlock(block) {
    persistQueue = persistQueue.catch(() => {}).then(() => {
      const checkbox = block.querySelector('[data-gift-checkbox]');
      const textarea = block.querySelector('[data-gift-textarea]');
      const fromInput = block.querySelector('[data-gift-from]');
      if (!checkbox) return null;

      const isGift = checkbox.checked;
      const message = isGift ? (textarea?.value || '').trim() : '';
      const fromDefault = fromInput?.getAttribute('data-gift-from-default') || '';
      const fromValue = isGift ? (fromInput?.value || '').trim() || fromDefault : '';

      return saveGiftState({
        note: giftNoteText(isGift, message, fromValue),
        attributes: {
          [GIFT_ORDER_KEY]: isGift ? 'Yes' : 'No',
          [GIFT_MESSAGE_KEY]: message,
          [GIFT_FROM_KEY]: fromValue,
          [LEGACY_NOTE_KEY]: '',
        },
      });
    });
    return persistQueue;
  }

  function applyCartAttributes(cart) {
    const attributes = cart?.attributes || {};
    const isGift = attributes[GIFT_ORDER_KEY] === 'Yes';

    document.querySelectorAll('[data-cart-drawer] [data-gift-options]').forEach((block) => {
      const checkbox = block.querySelector('[data-gift-checkbox]');
      const textarea = block.querySelector('[data-gift-textarea]');
      const fromInput = block.querySelector('[data-gift-from]');
      if (!checkbox) return;

      checkbox.checked = isGift;
      if (textarea && document.activeElement !== textarea) {
        textarea.value = isGift
          ? attributes[GIFT_MESSAGE_KEY] || attributes[LEGACY_NOTE_KEY] || ''
          : '';
      }
      if (fromInput && document.activeElement !== fromInput) {
        const fromDefault = fromInput.getAttribute('data-gift-from-default') || '';
        fromInput.value = isGift ? attributes[GIFT_FROM_KEY] || fromDefault : fromDefault;
      }
      syncPanel(block);
    });
  }

  function bindBlock(block) {
    if (block.dataset.giftOptionsReady === 'true') return;

    const checkbox = block.querySelector('[data-gift-checkbox]');
    const textarea = block.querySelector('[data-gift-textarea]');
    const fromInput = block.querySelector('[data-gift-from]');
    if (!checkbox) return;

    const persistSoon = () => {
      window.clearTimeout(noteTimers.get(block));
      noteTimers.set(
        block,
        window.setTimeout(() => {
          persistFromBlock(block).catch((error) => console.error(error));
        }, NOTE_DEBOUNCE_MS),
      );
    };

    checkbox.addEventListener('change', () => {
      window.clearTimeout(noteTimers.get(block));
      if (checkbox.checked && fromInput && !fromInput.value.trim()) {
        fromInput.value = fromInput.getAttribute('data-gift-from-default') || '';
      }
      syncPanel(block);
      persistFromBlock(block).catch((error) => console.error(error));
    });

    if (textarea) {
      textarea.addEventListener('input', () => {
        updateCount(block);
        if (!checkbox.checked) return;
        persistSoon();
      });
      textarea.addEventListener('blur', () => {
        if (!checkbox.checked) return;
        window.clearTimeout(noteTimers.get(block));
        persistFromBlock(block).catch((error) => console.error(error));
      });
    }

    if (fromInput) {
      fromInput.addEventListener('input', () => {
        if (!checkbox.checked) return;
        persistSoon();
      });
      fromInput.addEventListener('blur', () => {
        if (!checkbox.checked) return;
        window.clearTimeout(noteTimers.get(block));
        persistFromBlock(block).catch((error) => console.error(error));
      });
    }

    syncPanel(block);
    block.dataset.giftOptionsReady = 'true';
  }

  function initGiftOptions(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-gift-options]').forEach(bindBlock);
  }

  function isCheckoutTrigger(target) {
    if (!target || !target.closest) return false;
    if (target.closest('[name="checkout"]')) return true;
    if (target.closest('magic-checkout-btn')) return true;
    if (target.closest('[data-magic-checkout]')) return true;
    return false;
  }

  document.addEventListener(
    'click',
    (event) => {
      if (checkoutFlushing) return;
      if (!isCheckoutTrigger(event.target)) return;

      const block = cartGiftBlock();
      if (!block) return;

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      window.clearTimeout(noteTimers.get(block));
      checkoutFlushing = true;

      persistFromBlock(block)
        .catch((error) => console.error(error))
        .then(() => {
          const magicReady = typeof window.openRzpCheckout === 'function';
          const magicHost = document.querySelector('[data-magic-checkout] magic-checkout-btn');
          if (magicReady && magicHost) {
            window.openRzpCheckout(event);
            return;
          }

          // Go straight to checkout. form.submit() without a submitter omits
          // name="checkout", which lands on /cart and our cart page redirects home.
          window.location.assign('/checkout');
        })
        .finally(() => {
          checkoutFlushing = false;
        });
    },
    true,
  );

  window.VanabrewGiftOptions = {
    applyCartAttributes,
    persistFromBlock,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initGiftOptions());
  } else {
    initGiftOptions();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initGiftOptions(event.target);
  });
})();
